const BASE_URL = "https://praneeshinfotech.com/kongudevapi/api/membership-plans";

const getHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const apiRequest = async (endpoint = "", options = {}) => {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
        ...options,
        headers: {
            ...getHeaders(),
            ...options.headers,
        },
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
        throw new Error(result.message || "Something went wrong");
    }

    return result;
};

export const getMembershipPlans = (status = "") => {
    const query = status ? `?status=${status}` : "";
    return apiRequest(query);
};

export const createMembershipPlan = (data) =>
    apiRequest("", {
        method: "POST",
        body: JSON.stringify(data),
    });

export const updateMembershipPlan = (rfId, data) =>
    apiRequest(`/${rfId}`, {
        method: "PUT",
        body: JSON.stringify(data),
    });

export const updateMembershipPlanStatus = (rfId, status) =>
    apiRequest(`/${rfId}/status`, {
        method: "PATCH",
        body: JSON.stringify({ status }),
    });

export const deleteMembershipPlan = (rfId) =>
    apiRequest(`/${rfId}`, {
        method: "DELETE",
    });